import useQuery from '@onepercentio/one-ui/hooks/utility/useQuery'
import { PurchaseType } from 'core/logic/purchase/purchase.types'
import { useMemo } from 'react'

export function usePaymentStatusOverrideForStripe(purchase: PurchaseType | null) {
  /** IF CREDIT_CARD */
  /** When we are working with Stripe, it reloads the page with the flag payed set to true */
  const payed = useQuery<{ payed: boolean }>().get('payed')

  return useMemo(() => {
    if (purchase)
      if (payed) {
        /** If stripe has said it's payed */
        /** Override the active status, as processing */
        if (purchase.paymentStatus === 'ACTIVE') return 'PROCESSING'
        else return purchase.paymentStatus
      } else {
        return purchase.paymentStatus
      }
  }, [purchase])
}
